import { Content } from '@radix-ui/react-accordion'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'

export type AccordionContentProps = ComponentPropsWithoutRef<typeof Content>

export const AccordionContent = forwardRef<
  ElementRef<typeof Content>,
  ComponentPropsWithoutRef<typeof Content>
>(({ className, children, ...props }, ref) => (
  <Content
    ref={ref}
    className="overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn('px-4 pt-0 pb-4', className)}>{children}</div>
  </Content>
))

AccordionContent.displayName = Content.displayName
